<template>
  <section>
    <b-field class="has-addons-centered">
      <b-button
        icon-left="page-first"
        type="is-primary"
        @click="page = 1"
        :disabled="page === 1"
      >
      </b-button>
      <b-button
        icon-left="chevron-left"
        type="is-primary"
        @click="page -= 1"
        :disabled="page === 1"
      >
      </b-button>

      <b-select
        icon="book-open-page-variant"
        v-model="page"
      >
        <option
          v-for="index in pageCount"
          :key="index"
          :value="index"
          :selected="index === currentPage">
          {{ index }} / {{ pageCount }}
        </option>
      </b-select>

      <b-button
        icon-right="chevron-right"
        type="is-primary"
        @click="page += 1"
        :disabled="page === pageCount"
      >
      </b-button>
      <b-button
        icon-right="page-last"
        type="is-primary"
        @click="page = pageCount"
        :disabled="page === pageCount"
      >
      </b-button>
    </b-field>
  </section>
</template>

<script>

export default {
  name: 'PdfViewerControls',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    pageCount: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      page: this.currentPage
    }
  },
  methods: {
    turnPage (event) {
      if ((event.key === 'ArrowRight') && (this.page < this.pageCount)) {
        this.page += 1
      } else if ((event.key === 'ArrowLeft') && (this.page > 1)) {
        this.page -= 1
      }
    }
  },
  created () {
    window.addEventListener('keydown', this.turnPage)
  },
  destroyed () {
    window.removeEventListener('keydown', this.turnPage)
  },
  watch: {
    page: function (value) {
      this.$emit('pageChanged', value)
    }
  }
}
</script>
